export default __webpack_public_path__ + "static/media/image11-2.a674915c.png";